<template>
  <div class="animated fadeIn">
    <div class="container-custom">
      <div class="ops__wrapper">
        <div class="ops__header">
          <div class="ops__title" id="traffic">Reports</div>
        </div>
        <div class="ops__tab-navigation">
          <TabNavigation :list="tabNavigation" :active="activeTab" :class="'fixed-width'" @change="changeTab" />
        </div>
        <div class="ops__info">
          <div class="ops__info-date">
            {{ todaysfulldate }}
          </div>
          <div class="ops__info-btn">
            <div class="info-btn">
              <div class="info-btn__item">
                <div class="btn-csv" @click.preventDefault="getDataAsCSV">
                  <i class="icon-cloud-download"></i> CSV
                </div>
              </div>
              <div class="info-btn__item info-btn__item--time" v-if="activeTab === 1">
                <div class="info-period">
                  <div class="info-period__item" :class="period === 'week' ? 'active' : ''" @click="() => changePeriod('week')">Week</div>
                  <div class="info-period__item" :class="period === 'month' ? 'active' : ''" @click="() => changePeriod('month')">Month</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="full-w">
      <div class="ops__tables">
        <b-row>
          <b-col cols="12">
            <b-card-group class="table-custom points-table" v-if="activeTab === 1">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header points" slot="header">
                  <div class="table-custom__header-wrap">
                    <img src="/img/left-arrow.png" alt="" @click="prevPeriod">
                    <h6  class="mb-0 text-center">{{ getDateForPeriod }}</h6>
                  </div>
                  <div class="table-custom__header-wrap">
                    <div @click="toggleDetails" class="table-custom__details">{{ hideDetail ? 'Show details' : 'Hide details' }}</div>
                    <img src="/img/right-arrow.png" alt="" @click="nextPeriod">
                  </div>
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped :table-class="hideDetail && 'hide'"
                         class="formatlastrow" thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_points">
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
            <b-card-group class="table-custom activity-table" v-else-if="activeTab === 2">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="table-custom__header-wrap">
                    <div class="table-custom__select table-custom__select--activity" v-if="therapists">
                      <div class="select__label">Therapist</div>
                      <v-select class="select" :options="therapists" v-model="therapistSelected" @input="getData" />
                    </div>
                    <div class="table-custom__picker">
                      <div class="date-picker__label">From</div>
                      <Datepicker
                        class="date-picker"
                        @selected="(e) => datePickerHandler('start', e)"
                        :disabledDates="{from: new Date(datePicker.endDate)}"
                        :value="datePicker.startDate"
                      />
                    </div>
                    <div class="table-custom__picker">
                      <div class="date-picker__label">To</div>
                      <Datepicker
                        class="date-picker"
                        @selected="(e) => datePickerHandler('end', e)"
                        :disabledDates="{to: new Date(datePicker.startDate)}"
                        :value="datePicker.endDate"
                      />
                    </div>
                    <div class="table-custom__checkbox">
                      <b-form-checkbox
                          v-model="apps_only"
                          @change="getData"
                          name="apps-only">Apps Only</b-form-checkbox>
                    </div>
                  </div>
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_activity">
                  <template slot="reason" slot-scope="d">
                    <div class="reason">{{d.value}}</div>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
            <b-card-group class="table-custom" v-if="activeTab === 3">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header points" slot="header">
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant" :table-class="'verif-table'"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_verif">
                  <template slot="activity_note" slot-scope="d">
                    <div class="note">{{d.value}}</div>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
            <b-card-group class="table-custom cases-table" v-else-if="activeTab === 4">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="table-custom__header-wrap">
                    <div class="table-custom__select" v-if="therapists">
                      <div class="select__label">Therapist</div>
                      <v-select class="select" :options="therapists" v-model="therapistSelected" @input="getData" />
                    </div>
                    <div class="table-custom__select">
                      <div class="select__label">Condition</div>
                      <v-select class="select" :options="conditionOptions" v-model="conditionSelected" @input="getData" />
                    </div>
                  </div>
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         :tbody-tr-class="totVariant"
                         thead-tr-class="text-nowrap small"
                         :busy="current_week_table_busy"
                         :items="filteredReports"
                         :fields="fields_cases">
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
            <b-card-group class="table-custom" v-else-if="activeTab === 5">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         thead-tr-class="text-nowrap small" :table-class="'leads-table'"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_leads">
                  <template slot="created" slot-scope="d">
                    <span class="no-wrap">{{d.value}}</span>
                  </template>
                  <template slot="eval_scheduled" slot-scope="d">
                    <span class="no-wrap">{{d.value}}</span>
                  </template>
                  <template slot="verified" slot-scope="d">
                    <span class="no-wrap">{{d.value}}</span>
                  </template>
                  <template slot="last_activity" slot-scope="d">
                    <span class="no-wrap">{{d.value}}</span>
                  </template>
                  <template slot="eval_date" slot-scope="d">
                    <span class="no-wrap">{{d.value}}</span>
                  </template>
                  <template slot="case" slot-scope="d">
                    <div class="note">{{d.value}}</div>
                  </template>
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
            <b-card-group class="table-custom activity-table" v-else-if="activeTab === 6">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="table-custom__header-wrap">
                    <div class="table-custom__picker">
                      <div class="date-picker__label">From</div>
                      <Datepicker
                        class="date-picker"
                        @selected="(e) => datePickerHandler('start', e)"
                        :disabledDates="{from: new Date(mileageDatePicker.endDate)}"
                        :value="mileageDatePicker.startDate"
                      />
                    </div>
                    <div class="table-custom__picker">
                      <div class="date-picker__label">To</div>
                      <Datepicker
                        class="date-picker"
                        @selected="(e) => datePickerHandler('end', e)"
                        :disabledDates="{to: new Date(mileageDatePicker.startDate)}"
                        :value="mileageDatePicker.endDate"
                      />
                    </div>
                  </div>
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         thead-tr-class="text-nowrap small"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_mileage">
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>

            <b-card-group class="table-custom activity-table" v-else-if="activeTab === 7">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         thead-tr-class="text-nowrap small"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_leads_to_check">
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>

            <b-card-group class="table-custom activity-table" v-else-if="activeTab === 8">
              <!-- <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="table-custom__header-wrap">
                    <div class="table-custom__checkbox">
                      <b-form-checkbox
                          v-model="summary"
                          @change="getData"
                          name="apps-only">Summary</b-form-checkbox>
                    </div>
                  </div>
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         thead-tr-class="text-nowrap small" :tbody-tr-class="totVariant"
                         :busy="current_week_table_busy" :items="filteredReports" :fields="fields_pt_visit_counts">
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card> -->
              <b-card>
                <div>
                  <b-form-checkbox v-model="summary" @change="getData" name="apps-only">
                    Summary
                  </b-form-checkbox>
                </div>
                <div class="nrc-table">
                  <div class="nrc-table-row nrc-table-header">
                    <div class="nrc-table-td" :key="col.key" v-for="(col, i) of fields_pt_visit_counts" v-bind:class="{ 'nrc-table-td-right': i >= 5 || i === 3 }">
                      {{ col.label }}
                    </div>
                  </div>
                  <RecycleScroller class="nrc-table-scroller" :items="filteredReports" :item-size="40" v-slot="{ item, index }">
                    <div class="nrc-table-row" v-bind:class="{ 'nrc-table-row-odd': index % 2 === 1 }">
                      <div class="nrc-table-td" v-bind:class="{ 'nrc-table-td-right': i >= 5 || i === 3 }" :key="col.key" v-for="(col, i) of fields_pt_visit_counts">
                        {{ item[col.key] }}
                      </div>
                    </div>
                  </RecycleScroller>
                </div>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment-timezone'
  import { isNumber } from 'util';
  import { formatDate } from '../shared/utils'
  import TabNavigation from './base/TabNavigation';
  import Datepicker from 'vuejs-datepicker';

  const qs = require('qs');
  export default {
    name: 'Reports',
    components: {
      TabNavigation,
      Datepicker
    },
    computed: {
      getDateForNextPeriod: function () {
        return this.getDateForHdr(1)
      },
      getDateForPeriod: function () {
        return this.getDateForHdr(0)
      },
      filteredReports: function () {
        return this.reports.map(r => ({id: `${r.month}-${r.patient}`, ...r}))

        const data = [...this.reports];
        const field = this.sortBy.field;
        if (!field) {
          return this.reports;
        }

        let fieldType;

        this.reports.forEach(item => {
          if (item[field] && typeof this.reports[0][field] === 'number') {
            fieldType = true;
            return;
          }
        });

        if(fieldType) {
          data.sort((a, b) => {
            if (!a[field] || !b[field]) {
              return a;
            }
            return a[field] - b[field];
          });
          if (this.sortBy.s === 2) {
            return [...data.reverse()];
          } else if (this.sortBy.s === 0) {
            return this.reports;
          }
          return [...data];
        }

        data.sort((a, b) => {
          if (!a[field]) {
            a[field] = '';
          }
          if (!b[field]) {
            b[field] = '';
          }
          return a[field].toString().localeCompare(b[field].toString())
        });
        if (this.sortBy.s === 2) {
          return data.reverse();
        } else if (this.sortBy.s === 0) {
          return this.reports;
        }
        return data;
      }
    },
    filters: {
      formatPercent: function (v) {
        if (isNumber(v)) {
          return Math.round(v) + '%'
        }
      },
      formatAccurateNumber: function (v) {
        if (isNumber(v)) {
          return v.toFixed(2) + ''
        }
      },
      capitalizeFirst: function (v) {
        if (typeof v == 'string') {
          return v.charAt(0).toUpperCase() + v.substring(1).toLowerCase();
        }
      },
    },
    data: function () {
      return {
        sortBy: {
          field: '',
          s: 0,
          i: null
        },
        tableHeader: null,
        therapists: null,
        therapistSelected: { label: 'All', code: 'all'},
        conditionSelected: { label: 'All', code: 'all'},
        conditionOptions: [
          { label: 'All', code: 'all'},
          { label: 'On Hold', code: 'on_hold'},
          { label: 'Zero', code: 'nonext'},
          { label: 'One', code: 'onenext'},
          { label: 'Zero/One', code: 'zero_one'},
          { label: 'Inactive', code: 'inactive'},
          { label: 'Over Rx', code: 'overrx'},
          { label: 'Over Ins', code: 'overins'},
        ],
        hideDetail: true,
        datePicker: {
          startDate: null,
          endDate: null,
        },
        mileageDatePicker: {
          startDate: null,
          endDate: null,
        },
        activeTab: 8,
        tabNavigation: [
          {
            id: 4,
            title: 'Open Cases',
          },
          {
            id: 2,
            title: 'Activity report',
          },
          {
            id: 3,
            title: 'Verif Not Ready',
          },
          {
            id: 1,
            title: 'Points report',
          },
          {
            id: 5,
            title: 'Leads',
          },
          {
            id: 6,
            title: 'Mileage',
          },
          {
            id: 7,
            title: 'Leads to Check',
          },
          {
            id: 8,
            title: 'NRC Counts',
          }
        ],
        todaysfulldate: moment().format('LLLL'),
        dateForData: new Date(),
        countPeriod: 0,
        csv: null,
        period: 'week',
        reports: [],
        current_week_table_busy: true,
        fields_points: [
          {key: 'therapist', label: 'Therapist'},
          {key: 'period', label: 'Period'},
          {key: 'Cash Eval', label: 'Cash E'},
          {key: 'Cash Treat', label: 'Cash T'},
          {key: 'Flat Eval', label: 'Flat E'},
          {key: 'Flat Treat', label: 'Flat T'},
          {key: 'Private Eval', label: 'Private E'},
          {key: 'Private Treat', label: 'Private T'},
          {key: 'Medicare Eval', label: 'Medicare E'},
          {key: 'Medicare Treat', label: 'Medicare T'},
          {key: 'Silver Eval', label: 'Silver E'},
          {key: 'Silver Treat', label: 'Silver T'},
          {key: 'Patient/Doctor', label: 'Pt/Dr Visit'},
          {key: 'HQ Meeting', label: 'HQ Meeting'},
          {key: 'Operations', label: 'Operations'},
          {key: 'visits', label: 'Visits'},
          {key: 'goal', label: 'Goal'},
          {key: 'points', label: 'Points'},
        ],
        fields_activity: [
          {key: 'therapist', label: 'Therapist'},
          {key: 'date', label: 'Date'},
          {key: 'patient', label: 'Patient'},
          {key: 'app_type', label: 'App type'},
          {key: 'duration', label: 'Duration'},
          {key: 'status', label: 'Status'},
          {key: 'ins_desc', label: 'Ins'},
          {key: 'reason', label: 'Reason'},
          {key: 'points', label: 'Points'},
          {key: 'chg', label: 'Chg'},
        ],
        fields_verif: [
          {key: 'verification_reviewed_date', label: 'Verifed'},
          {key: 'region', label: 'Region'},
          {key: 'patient', label: 'Patient'},
          {key: 'activity_date', label: 'Activity'},
          {key: 'source', label: 'Source'},
          {key: 'activity_note', label: 'Note'},
          {key: 'zip_code', label: 'Zip code'},
        ],
        fields_cases: [
          {key: 'therapist', label: 'Therapist'},
          {key: 'patient', label: 'Patient'},
          {key: 'description', label: 'Case'},
          {key: 'patient_phone', label: 'Phone'},
          {key: 'last_visit', label: 'Last Visit'},
          {key: 'to_ops', label: 'To Ops'},
          {key: 'insurance', label: 'Insurance'},
          {key: 'region', label: 'Region'},
          {key: 'patient_email', label: 'Email'},
          {key: 'visits', label: 'Treated'},
          {key: 'scheduled', label: 'Sched'},
          {key: 'total_prescribed_visits', label: 'Rx'},
          {key: 'ins_available_visits', label: 'Ins'},
        ],
        fields_leads: [
          {key: 'referring_doctor', label: 'Referring Dr'},
          {key: 'lead_status', label: 'Lead Stat'},
          {key: 'patient', label: 'Patient'},
          {key: 'insurance', label: 'Insurance'},
          {key: 'case', label: 'Case'},
          {key: 'created', label: 'Created'},
          {key: 'verified', label: 'Verified'},
          {key: 'eval_scheduled', label: 'Eval Sched'},
          {key: 'last_activity', label: 'Last Activity'},
          {key: 'eval_date', label: 'Eval Date'},
          {key: 'ver_to_sched', label: 'Ver to Sched'},
          {key: 'activities', label: 'Activities'},
          {key: 'region', label: 'Region'},
        ],
        fields_mileage: [
          {key: 'Therapist', label: 'Therapist'},
          {key: 'Date', label: 'Date'},
          {key: 'Type', label: 'Type'},
          {key: 'Miles', label: 'Miles'},
          {key: 'Patient1', label: 'Patient1'},
          {key: 'Address1', label: 'Address1'},
          {key: 'Patient2', label: 'Patient2'},
          {key: 'Address2', label: 'Address2'},
        ],
        fields_leads_to_check : [
          {key: 'lead_id', label: 'Lead ID'},
          {key: 'caller', label: 'Caller'},
          {key: 'last_activity_date', label: 'Last Activity Date'},
          {key: 'ndays', label: 'Days'},
          {key: 'status', label: 'Status'},
          {key: 'comment', label: 'Comment'},
          {key: 'notes', label: 'Notes'},
        ],
        fields_pt_visit_counts: [
          {key: 'month', label: 'Month'},
          {key: 'patient', label: 'Patient'},
          {key: 'pat_first_visit', label: 'First Vist'},
          {key: 'case_num', label: 'Case Num'},
          {key: 'case_first_visit', label: 'Case First Visit'},
          {key: 'new_pt_visits', label: 'New PT visits'},
          {key: 'rtn_pt_visits', label: 'Rtn PT visits'},
          {key: 'cont_pt_visits', label: 'Cont PT visits'},
          {key: 'tot_pt_visits', label: 'Tot PT visits'},
          {key: 'new_pts', label: 'New pts'},
          {key: 'rtn_pts', label: 'Rtn PTS'},
          {key: 'cont_pts', label: 'Cont PTS'},
          {key: 'tot_pts', label: 'PTS/Month'},
          {key: 'pt_in_sys', label: 'PTS in System'}
        ],
        apps_only: false,
        summary: true,
      }
    },
    async mounted() {
      this.datePicker.startDate = this.getDate(0);
      this.datePicker.endDate = this.getDate(2);
      this.mileageDatePicker.startDate = this.getDate(-1);
      this.mileageDatePicker.endDate = this.getDate(0);
      this.countPeriod = -5;
      this.getData();
      this.getTheraplists();
      this.setCurrentTime();
    },
    methods: {
      sort(i, field) {
        this.sortBy.i = i;
        let items;
        if (this.activeTab === 1) {
          items = this.fields_points;
        } else if (this.activeTab === 2) {
          items = this.fields_activity;
        } else if (this.activeTab === 3) {
          items = this.fields_verif;
        } else if (this.activeTab === 4) {
          items = this.fields_cases;
        } else if (this.activeTab === 5) {
          items = this.fields_leads;
        } else if (this.activeTab === 6) {
          items = this.fields_mileage;
        } else if (this.activeTab === 7) {
          items = this.fields_leads_to_check;
        } else if (this.activeTab === 8) {
          items = this.fields_pt_visit_counts;
        }

        for(let i of items) {
          if (i.label === field) {
            this.sortBy.field = i.key;
            break;
          }
        }

        if (this.sortBy.s < 2) {
          this.sortBy = {...this.sortBy, s: this.sortBy.s + 1}
        } else {
          this.sortBy = {...this.sortBy, s: 0}
        }
      },
      async getTheraplists() {
        const endpoint = `/therapists?active=true`;
        try {
          const res = await this.$newpetehealthapi.get(endpoint, {
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });
          this.therapists = res.data.map(item => {
            item.label = `${item.last_name}, ${item.first_name}`;
            return item;
          });
          this.therapists.unshift({ label: 'All', code: 'all'});
        } catch (e) {
          return null;
        }
      },

      async getCases() {
        this.current_week_table_busy = true;
        const endpoint = `/cases`;
        const params = { open: 'only' };

        if (this.therapistSelected.code !== 'all') {
          params.therapist_id = this.therapistSelected.id;
        }
        if (this.conditionSelected.code !== 'all') {
          params[this.conditionSelected.code] = 'only';
        }
        try {
          const r = await this.$newpetehealthapi.get(endpoint, {
            params,
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });
          return r.data;
        } catch (e) {
          return [];
        }
        this.current_week_table_busy = false;
      },

      async getReport(url, period, since, until, therapist_id, apps_only, summary) {
        const baseURL = (process.env.VUE_APP_RUBY_URL || 'https://devopstest.petehealth.com:8080') + '/report';
        const endpoint = `${baseURL}/${url}`;
        let params = {};
        if (url == 'points') {
          params = { period, since, until };
        } else if (url == 'activity') {
          params = { since, until, therapist_id ,apps_only};
        } else if (url === 'mileage') {
          params = { from: since, to: until };
        } else if (url === 'pt_visit_counts') {
          params = { summary };
        }

        try {
          const r = await this.$newpetehealthapi.get(endpoint, {
            params: params,
            paramsSerializer: params => {
              return qs.stringify(params)
            }
          });
          return r.data;
        } catch (e) {
          return [];
        }
      },

      async getData() {
        this.current_week_table_busy = true;
        const id = this.activeTab;
        const date = this.getDateForData(0);

        if (id === 1) {
          this.reports = await this.getReport('points', this.period, date);
        } else if (id === 2) {
          this.reports = await this.getReport('activity', this.period, formatDate(this.datePicker.startDate), formatDate(this.datePicker.endDate), this.therapistSelected.id, this.apps_only);
        } else if (id === 3) {
          this.reports = await this.getReport('verif', this.period, date);
        } else if (id === 4) {
          this.reports = await this.getCases();
        } else if (id === 5) {
          this.reports = await this.getReport('leads');
        } else if (id === 6) {
          this.reports = await this.getReport('mileage', null, formatDate(this.mileageDatePicker.startDate), formatDate(this.mileageDatePicker.endDate));
        } else if (id === 7) {
          this.reports = await this.getReport('leads_to_check');
        } else if (id === 8) {
          this.reports = await this.getReport('pt_visit_counts', null, null, null, null, null, this.summary);
        }

        this.current_week_table_busy = false;

        this.sortBy = {
          field: '',
          s: 0,
          i: 0
        };

        this.renderHeader();
      },

      renderHeader() {
        setTimeout(() => {
          const data = [];
          const item = document.querySelector('thead tr').children;
          for (let i = 0; i < item.length; i++) {
            data.push({w: item[i].clientWidth, label: item[i].innerText});
          }

          this.tableHeader = data;
        });
      },

      async datePickerHandler(type, date) {
        const id = this.activeTab;
        this.current_week_table_busy = true;

        if (id === 2) {
          if (type === 'start') {
            this.datePicker.startDate = date;
          } else {
            this.datePicker.endDate = date;
          }
          this.reports = await this.getReport('activity', this.period, formatDate(this.datePicker.startDate), formatDate(this.datePicker.endDate), this.therapistSelected.id, this.apps_only);
        } else {
          if (type === 'start') {
            this.mileageDatePicker.startDate = date;
          } else {
            this.mileageDatePicker.endDate = date;
          }
          this.reports = await this.getReport('mileage', null, formatDate(this.mileageDatePicker.startDate), formatDate(this.mileageDatePicker.endDate));
        }
        this.current_week_table_busy = false;
      },

      changeTab(id) {
        this.activeTab = id;
        this.countPeriod = id === 1 ? -5 : 0;
        this.therapistSelected = { label: 'All', code: 'all'};
        this.conditionSelected = { label: 'All', code: 'all'};
        this.sortBy = {
          field: '',
          s: 0,
          i: 0
        };
        this.getData();
      },

      nextPeriod() {
        this.countPeriod += 1;
        this.getData();
      },

      prevPeriod() {
        this.countPeriod -= 1;
        this.getData();
      },

      changePeriod(data) {
        this.countPeriod = this.activeTab === 1 ? -5 : 0;
        this.period = data;
        this.getData();
      },

      getDate(period) {
        const d = this.dateForData;
        if (this.period === 'week') {
          const curDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
          return moment(curDay).add((this.countPeriod + period) * 7 - (d.getDay() + 6) % 7, 'days').toDate();
        } else {
          const curMon = new Date(d.getFullYear(), d.getMonth());
          return moment(curMon).add((this.countPeriod + period), 'months').toDate();
        }
      },

      getDateForHdr(period) {
        const fmtStr = (this.period === 'week') ? 'DD  MMM YYYY' : 'MMM YYYY';
        return moment(this.getDate(period)).format(fmtStr);
      },

      getDateForData(period) {
        return moment(this.getDate(period)).format('YYYY-MM-DD');
      },

      setCurrentTime() {
        this.todaysfulldate = moment().format("LLLL")
      },

      totVariant(c) {
        if (c == undefined) return
        let classStr = "text-nowrap"; // Default classes
        let cName = c.therapist || c.region ||'';
        if (cName.match(/Total/))
          classStr += ' bg-dark';
        else if (cName.match(/Subtotal/))
          classStr += ' text-dark bg-primary';

        if (c.status) {
          if (c.status === 'On Hold')
            classStr += ' row-blue';
          else if ((((c.visits + c.scheduled) > parseInt(c.total_prescribed_visits)) || c.total_prescribed_visits === null) &&
            (c.insurance != 'NONE'))
            classStr += ' row-red';
          else if (((c.visits + c.scheduled) > parseInt(c.ins_available_visits)) && (
            ((c.insurance != 'Noridian Medicare') || !c.abn_received)))
            classStr += ' row-red';
          else if (c.scheduled < 2)
            classStr += ' row-yellow';
        }
        return classStr;
      },

      getDataAsCSV() {
        const baseURL = (process.env.VUE_APP_RUBY_URL || 'https://devopstest.petehealth.com:8080') + '/report';
        const id = this.activeTab;
        const params = { csv: true };
        let endpoint = `${baseURL}`
        var filename;
        if (id === 1) {
          endpoint += '/points';
          params.period = this.period;
          params.since = this.getDateForData(0);
          filename = 'points_report_'+moment(new Date()).format('YYYYMMDD')+'.csv';
        } else if (id === 2) {
          endpoint += '/activity';
          if (this.therapistSelected.code !== 'all') {
            params.therapist_id = this.therapistSelected.id;
          }
          params.since = formatDate(this.datePicker.startDate);
          params.until = formatDate(this.datePicker.endDate);
          filename = 'activity_report_' +
            moment(params.since).format('YYYYMMDD') + '_' +
            moment(params.until).format('YYYYMMDD') + '.csv';
        } else if (id === 3) {
          endpoint += '/verif';
          filename = 'verif_not_ready_'+moment(new Date()).format('YYYYMMDD')+'.csv';
        } else if (id === 4) {
          endpoint += '/cases';
          filename = 'open_cases_'+moment(new Date()).format('YYYYMMDD')+'.csv';
          params.open = 'only';

          if (this.therapistSelected.code !== 'all') {
            params.therapist_id = this.therapistSelected.id;
          }
          if (this.conditionSelected.code !== 'all') {
            params[this.conditionSelected.code] = 'only';
          }
        } else if (id === 5) {
          endpoint += '/leads';
          filename = 'leads_'+moment(new Date()).format('YYYYMMDD')+'.csv';
        } else if (id === 6) {
          endpoint += '/mileage';
          params.since = formatDate(this.mileageDatePicker.startDate);
          params.until = formatDate(this.mileageDatePicker.endDate);
          filename = 'mileage_report_' +
            moment(params.since).format('YYYYMMDD') + '_' +
            moment(params.until).format('YYYYMMDD') + '.csv';
        } else if (id === 7) {
          endpoint += '/leads_to_check';
          filename = 'leads_to_check_'+moment(new Date()).format('YYYYMMDD')+'.csv';
        } else if (id === 8) {
          endpoint += '/pt_visit_counts';
          params.summary = this.summary;
          filename = 'pt_visit_counts_'+moment(new Date()).format('YYYYMMDD')+'.csv';
        }

        this.$newpetehealthapi.get(endpoint, {
          params: params,
          paramsSerializer: params => {
            return qs.stringify(params)
          }
        }).then( (r) => {
          const url = window.URL.createObjectURL(new Blob([r.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
      },

      toggleDetails() {
        this.hideDetail = !this.hideDetail;
        this.renderHeader();
      },
    },
  }
</script>

<style lang="scss">
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  table.b-table[aria-busy='true'] {
    opacity: 0.4;
  }
  .formatlastrow tr:last-child {
    border-top: double;
  }

  .tableFixedHeader {
    display: flex;
    background-color: #eff0f2;
    margin: 0 -20px;
    &Arrow {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 15px;
      cursor: pointer;
      margin-right: -4px;
      &.up {
        &:before {
          border-bottom: 5px solid #46505c;
        }
      }
      &.down {
        &:after {
          border-top: 5px solid #46505c;
        }
      }
      &:before {
        display: block;
        content: "";
        border: 4px solid transparent;
        border-bottom: 5px solid #73818f;
        margin-bottom: 3px;
        transition: .3s;
      }
      &:after {
        display: block;
        content: "";
        border: 4px solid transparent;
        border-top: 5px solid #73818f;
        transition: .3s;
      }
    }
  }
  .tableFixedHeaderItem {
    height: 47px;
    display: flex;
    align-items: center;
    overflow: hidden;
    font-size: 14px;
    color: rgba(0, 35, 78, 0.6);
    font-weight: bold;
    padding: 0 .3rem;
    cursor: pointer;
    &:first-child {
       padding: 0 20px;
     }
  }
  .no-wrap {
    white-space: nowrap;
  }

  .full-w {
    width: 100%;
    max-width: calc(1920px - 30px);
    margin: 0 auto;
  }

  // ======================================================
  // NRC Table Report
  // ======================================================

  .nrc-table {
    --width: 1848px;
    --border: solid 1px #ddd;

    border: var(--border);
    overflow-x: auto;

    .vue-recycle-scroller__item-wrapper {
      width: var(--width);
    }
  }

  .nrc-table-scroller {
    height: 65vh;
    width: var(--width);
  }

  .nrc-table-row {
    display: grid;
    grid-template-columns: 150px 300px 150px 75px 150px repeat(9, 75px);
    grid-gap: 16px;
  }

  .nrc-table-td {
    height: 40px;
    display: flex;
    align-items: center;
    font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,monospace;
  }

  .nrc-table-td-right {
    text-align: right;
    justify-self: right;
  }

  .nrc-table-row-odd {
    background-color: var(--light);
  }

  .nrc-table-header {
    width: var(--width);
    border-bottom: var(--border);
    background: #fafafa;
    .nrc-table-td {
      font-family: inherit;
    }
  }

</style>
